// src/web-app/auth/auth-ui.js
import { getAuth } from './auth-handler.js';
import { handleLogout, handleSignIn, handleCreateAccount, handleGoogleSignIn, getAuthReadyPromise } from './auth-handler.js';

export function showUserInfo() {
  const auth = getAuth();
  const userInfoEl = document.getElementById('user-info');
  const userEmailEl = document.getElementById('user-email');
  const logoutBtn = document.getElementById('btn-logout');
  
  if (auth.currentUser && userInfoEl && userEmailEl) {
    userInfoEl.style.display = 'flex';
    userEmailEl.textContent = auth.currentUser.email;
    
    // Wire up logout button
    if (logoutBtn) {
      logoutBtn.addEventListener('click', async () => {
        const success = await handleLogout();
        if (success) {
          showAuthForm();
        }
      });
    }
  }
}

export function showAuthForm() {
  const authOverlay = document.getElementById('auth-overlay');
  if (authOverlay) {
    authOverlay.style.display = 'flex';
    
    // Only set up event listeners once (check for a flag)
    if (!window.__AUTH_FORM_WIRED__) {
      window.__AUTH_FORM_WIRED__ = true;
      
      // Set up event listeners
      document.getElementById('btn-signin').addEventListener('click', async () => {
        const email = document.getElementById('auth-email').value;
        const password = document.getElementById('auth-password').value;
        
        try {
          hideError();
          hideSuccess();
          showLoading('Signing in...');
          setButtonsEnabled(false);
          
          await handleSignIn(email, password);
          
          // Show loading overlay
          const loadingOverlay = document.getElementById('loading-overlay');
          const loadingMessage = document.querySelector('.loading-message');
          if (loadingOverlay) {
            loadingOverlay.style.display = 'flex';
            if (loadingMessage) {
              loadingMessage.textContent = 'Loading application...';
            }
          }
          
          // Show user info
          showUserInfo();
          
          // Hide auth overlay
          document.getElementById('auth-overlay').style.display = 'none';
          
          // Wait for app initialization to complete, then hide loading overlay
          // The app initialization code in index.js waits for getAuthReadyPromise()
          // and sets up the UI. We'll hide the overlay after a short delay to allow
          // the app to finish initializing.
          try {
            await getAuthReadyPromise();
            // Give the app a moment to finish initializing
            setTimeout(() => {
              if (loadingOverlay) {
                loadingOverlay.style.display = 'none';
              }
            }, 500);
          } catch (error) {
            console.error('Error waiting for auth ready:', error);
            // Hide overlay anyway after a delay
            setTimeout(() => {
              if (loadingOverlay) {
                loadingOverlay.style.display = 'none';
              }
            }, 1000);
          }
        } catch (error) {
          console.error('Sign in error:', error);
          hideLoading();
          setButtonsEnabled(true);
          showError(error.message || 'Sign in failed');
        }
      });
      
      document.getElementById('btn-create-account').addEventListener('click', async () => {
        const email = document.getElementById('auth-email').value;
        const password = document.getElementById('auth-password').value;
        
        try {
          hideError();
          hideSuccess();
          showLoading('Creating account...');
          setButtonsEnabled(false);
          
          await handleCreateAccount(email, password);
          
          // Show success message
          showSuccess('Account created successfully! Loading application...');
          hideLoading();
          
          // Wait a moment to show the success message, then transition to loading overlay
          await new Promise(resolve => setTimeout(resolve, 1500));
          
          // Show loading overlay
          const loadingOverlay = document.getElementById('loading-overlay');
          const loadingMessage = document.querySelector('.loading-message');
          if (loadingOverlay) {
            loadingOverlay.style.display = 'flex';
            if (loadingMessage) {
              loadingMessage.textContent = 'Loading application...';
            }
          }
          
          // Show user info
          showUserInfo();
          
          // Hide auth overlay
          document.getElementById('auth-overlay').style.display = 'none';
          
          // Wait for app initialization to complete, then hide loading overlay
          try {
            await getAuthReadyPromise();
            // Give the app a moment to finish initializing
            setTimeout(() => {
              if (loadingOverlay) {
                loadingOverlay.style.display = 'none';
              }
            }, 500);
          } catch (error) {
            console.error('Error waiting for auth ready:', error);
            // Hide overlay anyway after a delay
            setTimeout(() => {
              if (loadingOverlay) {
                loadingOverlay.style.display = 'none';
              }
            }, 1000);
          }
        } catch (error) {
          console.error('Create account error:', error);
          hideLoading();
          setButtonsEnabled(true);
          showError(error.message || 'Account creation failed');
        }
      });
      
      document.getElementById('btn-google-signin').addEventListener('click', async () => {
        try {
          hideError();
          hideSuccess();
          showLoading('Redirecting to Google...');
          setButtonsEnabled(false);
          await handleGoogleSignIn();
        } catch (error) {
          console.error('Google sign in error:', error);
          hideLoading();
          setButtonsEnabled(true);
          showError(error.message || 'Google sign in failed');
        }
      });
      
      // Handle Enter key in password field
      document.getElementById('auth-password').addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          document.getElementById('btn-signin').click();
        }
      });
    }
  }
}

export function showError(message) {
  const errorEl = document.getElementById('auth-error');
  const successEl = document.getElementById('auth-success');
  const loadingEl = document.getElementById('auth-loading');
  if (errorEl) {
    errorEl.textContent = message;
    errorEl.style.display = 'block';
  }
  if (successEl) successEl.style.display = 'none';
  if (loadingEl) loadingEl.style.display = 'none';
}

export function hideError() {
  const errorEl = document.getElementById('auth-error');
  if (errorEl) {
    errorEl.style.display = 'none';
  }
}

export function showSuccess(message) {
  const successEl = document.getElementById('auth-success');
  const errorEl = document.getElementById('auth-error');
  const loadingEl = document.getElementById('auth-loading');
  if (successEl) {
    successEl.textContent = message;
    successEl.style.display = 'block';
  }
  if (errorEl) errorEl.style.display = 'none';
  if (loadingEl) loadingEl.style.display = 'none';
}

export function hideSuccess() {
  const successEl = document.getElementById('auth-success');
  if (successEl) {
    successEl.style.display = 'none';
  }
}

export function showLoading(message = 'Loading...') {
  const loadingEl = document.getElementById('auth-loading');
  const errorEl = document.getElementById('auth-error');
  const successEl = document.getElementById('auth-success');
  if (loadingEl) {
    const span = loadingEl.querySelector('span');
    if (span) span.textContent = message;
    loadingEl.style.display = 'flex';
  }
  if (errorEl) errorEl.style.display = 'none';
  if (successEl) successEl.style.display = 'none';
}

export function hideLoading() {
  const loadingEl = document.getElementById('auth-loading');
  if (loadingEl) {
    loadingEl.style.display = 'none';
  }
}

function setButtonsEnabled(enabled) {
  const signInBtn = document.getElementById('btn-signin');
  const createAccountBtn = document.getElementById('btn-create-account');
  const googleSignInBtn = document.getElementById('btn-google-signin');
  const emailInput = document.getElementById('auth-email');
  const passwordInput = document.getElementById('auth-password');
  
  [signInBtn, createAccountBtn, googleSignInBtn, emailInput, passwordInput].forEach(el => {
    if (el) {
      el.disabled = !enabled;
      if (el.tagName === 'BUTTON') {
        el.style.opacity = enabled ? '1' : '0.6';
        el.style.cursor = enabled ? 'pointer' : 'not-allowed';
      }
    }
  });
}






